const BASE = '/api/admin';

function authHeaders() {
  const token = sessionStorage.getItem('af_token');
  return { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` };
}

async function req(method, path, body) {
  const res = await fetch(BASE + path, {
    method,
    headers: authHeaders(),
    body: body ? JSON.stringify(body) : undefined,
  });
  let data = {};
  try { data = await res.json(); } catch (_) {}
  if (!res.ok) throw new Error(data.error || data.message || `Error ${res.status}`);
  return data;
}

export const getDashboard       = ()           => req('GET',   '/dashboard');
export const getCourses         = ()           => req('GET',    '/courses');
export const getCourse          = (id)         => req('GET',    `/courses/${id}`);
export const createCourse       = (body)       => req('POST',   '/courses', body);
export const updateCourse       = (id, body)   => req('PATCH',  `/courses/${id}`, body);
export const deleteCourse       = (id)         => req('DELETE', `/courses/${id}`);
export const getInstructors     = ()           => req('GET',    '/instructors');
export const getInstructor      = (id)         => req('GET',    `/instructors/${id}`);
export const createInstructor   = (body)       => req('POST',   '/instructors', body);
export const updateInstructor        = (id, body)   => req('PATCH',  `/instructors/${id}`, body);
export const deleteInstructor        = (id)         => req('DELETE', `/instructors/${id}`);
export const toggleInstructorStatus  = (id, body)   => req('PATCH',  `/instructors/${id}/status`, body);
export const getStudents           = ()           => req('GET',    '/students');
export const getStudent            = (id)         => req('GET',    `/students/${id}`);
export const createStudent         = (body)       => req('POST',   '/students', body);
export const updateStudent         = (id, body)   => req('PATCH',  `/students/${id}`, body);
export const deleteStudent         = (id)         => req('DELETE', `/students/${id}`);
export const toggleStudentStatus   = (id, body)   => req('PATCH',  `/students/${id}/status`, body);
export const enrollStudent      = (body)       => req('POST',   '/enrollments', body);
export const unenrollStudent    = (sId, cId)   => req('DELETE', `/enrollments/${sId}/${cId}`);
export const createModule       = (cId, body)        => req('POST',   `/courses/${cId}/modules`, body);
export const getModule          = (cId, mId)         => req('GET',    `/courses/${cId}/modules/${mId}`);
export const updateModule       = (cId, mId, body)   => req('PATCH',  `/courses/${cId}/modules/${mId}`, body);

export const addQuestion        = (cId, mId, body)          => req('POST',   `/courses/${cId}/modules/${mId}/questions`, body);
export const updateQuestion     = (cId, mId, qId, body)     => req('PATCH',  `/courses/${cId}/modules/${mId}/questions/${qId}`, body);
export const deleteQuestion     = (cId, mId, qId)           => req('DELETE', `/courses/${cId}/modules/${mId}/questions/${qId}`);

export const deleteResource     = (cId, mId, rId)           => req('DELETE', `/courses/${cId}/modules/${mId}/resources/${rId}`);
export const renameResource     = (cId, mId, rId, name)     => req('PATCH',  `/courses/${cId}/modules/${mId}/resources/${rId}`, { name });
export const addLinkResource    = (cId, mId, name, url)     => req('POST',   `/courses/${cId}/modules/${mId}/resources/link`, { name, url });

export const deleteVideo        = (cId, mId, vId)           => req('DELETE', `/courses/${cId}/modules/${mId}/videos/${vId}`);
export const renameVideo        = (cId, mId, vId, name)     => req('PATCH',  `/courses/${cId}/modules/${mId}/videos/${vId}`, { name });

export function uploadFile(courseId, moduleId, fileType, file, onProgress) {
  return new Promise((resolve, reject) => {
    const token = sessionStorage.getItem('af_token');
    const formData = new FormData();
    formData.append('file', file);
    const xhr = new XMLHttpRequest();
    xhr.upload.onprogress = (e) => {
      if (e.lengthComputable && onProgress) onProgress(Math.round(e.loaded / e.total * 100));
    };
    xhr.onload = () => {
      try {
        const json = JSON.parse(xhr.responseText);
        if (xhr.status >= 200 && xhr.status < 300) resolve(json);
        else reject(new Error(json.error || 'Upload failed'));
      } catch { reject(new Error('Upload failed')); }
    };
    xhr.onerror = () => reject(new Error('Network error during upload'));
    xhr.open('POST', `/api/admin/courses/${courseId}/modules/${moduleId}/upload/${fileType}`);
    xhr.setRequestHeader('Authorization', `Bearer ${token}`);
    xhr.send(formData);
  });
}
export const createAssignment   = (cId, body)        => req('POST',  `/courses/${cId}/assignments`, body);
export const updateAssignment   = (cId, aId, body)   => req('PATCH', `/courses/${cId}/assignments/${aId}`, body);

export const getCertificates    = ()           => req('GET',   '/certificates');
export const issueCertificate   = (enrollId)   => req('POST',  `/enrollments/${enrollId}/certificate`);

export const getUploadSettings    = ()     => req('GET',   '/settings/upload');
export const updateUploadSettings = (body) => req('PATCH', '/settings/upload', body);
